// extracted by mini-css-extract-plugin
export var option = "_5h-1";
export var optionActive = "_5h-2";
export var pill = "_5h-0";